var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dropdown",staticClass:"base-dropdown",class:{
        'base-dropdown--open': _vm.forceOpen,
        'base-dropdown--close': _vm.forceClose,
        'base-dropdown--clickable': _vm.clickable,
        'base-dropdown--clickable-open': _vm.clickable && _vm.trigger,
    }},[_c('div',{staticClass:"base-dropdown__activator",on:{"click":_vm.on}},[_vm._t("activator")],2),_c('div',{staticClass:"base-dropdown__body"},[_c('div',{staticClass:"base-dropdown__body-inner"},[_vm._t("dropdown",null,null,{ fastClose: _vm.fastClose })],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }